module.exports = __webpack_public_path__ + "img/plus-circle-40px.90889e5.svg";